import type { PerfilUsuario, StatusValidacaoEntrega } from '../types/database'

export type EtapaValidacao = 'fornecedor' | 'escola' | 'nutricionista'

export function etapaPorStatus(status: StatusValidacaoEntrega | null | undefined): EtapaValidacao | null {
  switch (status) {
    case null:
    case undefined:
    case 'pendente_fornecedor':
      return 'fornecedor'
    case 'pendente_escola':
      return 'escola'
    case 'pendente_nutricionista':
      return 'nutricionista'
    default:
      return null
  }
}

export function podeValidarEtapa(
  perfil: PerfilUsuario | undefined,
  etapa: EtapaValidacao,
  opts: {
    minhasEscolas?: boolean
    minhaRota?: boolean
    meuPlanejamentoLogistica?: boolean
  },
): boolean {
  if (!perfil) return false
  if (perfil === 'admin') return true
  if (etapa === 'fornecedor' && perfil === 'logistica') return !!opts.meuPlanejamentoLogistica
  if (etapa === 'escola' && perfil === 'responsavel_escola') return !!opts.minhasEscolas
  if (etapa === 'escola' && perfil === 'logistica') return false
  if (etapa === 'nutricionista' && perfil === 'nutricionista') return !!opts.minhaRota
  if (etapa === 'nutricionista' && perfil === 'logistica') return false
  return false
}

export function temDivergencia(
  itens: { qtd_planejada: number; qtd_recebida: string | number }[],
): boolean {
  return itens.some((i) => {
    const rec = Number(i.qtd_recebida)
    if (!Number.isFinite(rec)) return false
    return rec !== Number(i.qtd_planejada)
  })
}

export function validationBadgeClass(done: boolean, current: boolean) {
  if (done) return 'badge badge-ok'
  if (current) return 'badge badge-atencao'
  return 'badge badge-neutral'
}

export const ETAPA_LABELS: Record<EtapaValidacao, string> = {
  fornecedor: 'Logística',
  escola: 'Escola / CEACT',
  nutricionista: 'Nutricionista',
}
